import axios from 'axios';
import authService from './AuthService';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/$/, '');
const API_URL = `${API_BASE}/clients`;

const getAuthHeader = () => {
    const tokenData = authService.getCurrentToken();
    if (tokenData && tokenData.access_token) {
        return { Authorization: `Bearer ${tokenData.access_token}` };
    }
    return {};
};

const getClients = ({ skip = 0, limit = 100 } = {}) => {
    return axios.get(`${API_URL}/`, {
        params: { skip, limit },
        headers: getAuthHeader(),
    });
};

const getAllClients = async ({ chunkSize = 1000, maxItems = 20000 } = {}) => {
    const all = [];
    let skip = 0;

    while (true) {
        const response = await getClients({ skip, limit: chunkSize });
        const batch = response.data || [];
        all.push(...batch);

        if (batch.length < chunkSize) break;
        skip += chunkSize;
        if (all.length >= maxItems) break;
    }

    return all;
};

const getClient = (clientId) => {
    return axios.get(`${API_URL}/${clientId}`, { headers: getAuthHeader() });
};

const createClient = (clientData) => {
    return axios.post(`${API_URL}/`, clientData, { headers: getAuthHeader() });
};

const updateClient = (clientId, clientData) => {
    return axios.put(`${API_URL}/${clientId}`, clientData, { headers: getAuthHeader() });
};

const deleteClient = (clientId) => {
    return axios.delete(`${API_URL}/${clientId}`, { headers: getAuthHeader() });
};

const getClientServices = (clientId) => {
    return axios.get(`${API_URL}/${clientId}/services`, { headers: getAuthHeader() });
};

const searchClients = (query, limit = 20) => {
    return axios.get(`${API_URL}/search`, {
        params: { q: query, limit },
        headers: getAuthHeader(),
    });
};

const importClientsCsv = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_URL}/import`, formData, {
        headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data',
        },
    });
};

const clientService = {
    getClients,
    getAllClients,
    getClient,
    createClient,
    updateClient,
    deleteClient,
    getClientServices,
    searchClients,
    importClientsCsv,
};

export default clientService;
